var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"claim-type-step-claim-item flex row-gap-3 col-gap-8 pointer-events-none",class:_vm.wrapperClasses},[_c('div',{staticClass:"claim-item-radio-button-wrapper flex flex-col row-gap-2 w-full"},_vm._l((_vm.choices),function(choice,index){return _c('span',{key:`${choice}-${index}`,staticClass:"claim-item-radio-button w-full flex"},[_c('vs-radio',{key:`${choice}-${index}`,staticClass:"mr-4",attrs:{"value":false,"color":_vm.AISEA_COLOR.BLUE}},[_vm._v("\n        "+_vm._s(choice)+"\n      ")])],1)}),0),_c('div',{staticClass:"btn-area flex gap-3"},[_c('common-button',{staticClass:"save-btn-template",attrs:{"title":"保存","type":"filled","click":() => {},"btnStyle":{
        paddingLeft: 0,
        paddingRight: 0,
        width: '70px',
        height: '40px',
      },"disabled":""}}),_c('common-button',{staticClass:"cancel-btn-template",attrs:{"type":"border","color":"#BDBDBD","click":() => {},"btnStyle":{
        paddingLeft: 0,
        paddingRight: 0,
        width: '70px',
        height: '40px',
        fontSize: '12px',
        pointerEvents: 'none',
      },"text-color":"#757575","title":"キャンセル"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }